import { RouteObject } from "react-router-dom"
import { lazy } from "react"
import i18next from "i18next"
import { hasInternalModuleRoutePermission } from "@/util/permissions"

const ProtectedRoute = lazy(() => import("@/components/ProtectedRoute"))
const AllUsers = lazy(() => import("@/pages/AllUsers/AllUsers"))

const route: RouteObject = {
  path: "/users",
  element: (
    <ProtectedRoute
      hasPermission={hasInternalModuleRoutePermission("organisation")}
      redirectTo="/"
    >
      <AllUsers />
    </ProtectedRoute>
  ),
  handle: {
    pageTitle: () =>
      `${i18next.t("pageTitle.manageUsersPage", {
        ns: "organisation",
      })} - ${i18next.t("label.hitseeker", { ns: "common" })}`,
    title: () =>
      i18next.t("pageTitle.manageUsersPage", {
        ns: "organisation",
      }),
    crumb: () =>
      i18next.t("pageTitle.manageUsersPage", {
        ns: "organisation",
      }),
  },
}

export default route
